module.exports = __webpack_public_path__ + "img/ticket-code.1c756689.png";